import {
  LOGOUT,
  SET_CANDIDATES_ASSESSMENT_DATA,
  SET_CANDIDATES_DATA,
} from "../actions/action.types";

const initialState = {
  candidates: [],
  candidateAssessment: [],
};

const candidateReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_CANDIDATES_DATA:
      return { ...state, candidates: payload };
    case SET_CANDIDATES_ASSESSMENT_DATA:
      return { ...state, candidateAssessment: payload };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default candidateReducer;
